import { render } from "./LoginPage.vue?vue&type=template&id=242a23aa&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=242a23aa&scoped=true&lang=css"

import exportComponent from "/Users/michael/Desktop/Development/vue/login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242a23aa"]])

export default __exports__